module.exports = __webpack_public_path__ + "img/life-nfts.9998b7ad.svg";